import { Button, SimpleText, Text } from 'platform-components/common';
import React, { useCallback } from 'react';

import { useRegistrationLinkMetrika } from 'common.components/user/hooks';

import './class__add-school-panel.scss';

interface Props {
    onAddSchool: () => void;
}

export const AddSchoolPanel = ({ onAddSchool }: Props) => {
    const { ymTeacherAddSchool } = useRegistrationLinkMetrika();

    const handleClick = useCallback(() => {
        onAddSchool();
        ymTeacherAddSchool('my_classes');
    }, [onAddSchool, ymTeacherAddSchool]);

    return (
        <div className="class__add-school-panel">
            <Text id="class.addSchoolDescription" type={Text.TYPE.MARKDOWN} />
            <Button onClick={handleClick}>
                <SimpleText id="class.addSchoolButton" />
            </Button>
        </div>
    );
};
